





















































import Component from 'vue-class-component'
import { Contact, DynamicProperties } from '@/modules/pass/domain/pass'
import { Prop } from 'vue-property-decorator'
import { ContactType } from '@/modules/pass/types/contactType'
import Vue from 'vue'

@Component
export default class PassDetail extends Vue {
  @Prop({ type: DynamicProperties, required: true }) model!: DynamicProperties
  @Prop({ type: String, required: false }) title?: string

  createLink (contact: Contact) {
    switch (contact.type) {
      case ContactType.EMAIL:
        return '📧 ' + contact.name
      case ContactType.PHONE:
        return '☎️ ' + contact.name
      case ContactType.WEB: {
        return '🌐 ' + contact.name
      }
    }
  }

  createHref (contact: Contact) {
    switch (contact.type) {
      case ContactType.EMAIL:
        return 'mailto:' + contact.value
      case ContactType.PHONE:
        return 'tel:' + contact.value
      case ContactType.WEB: {
        const contactValue = contact.value!
        return contactValue.toLocaleLowerCase().startsWith('http') ? contactValue : 'http://' + contactValue
      }
    }
  }
}
